const PortfolioPage = ({ theme, onBackClick }) => {

  return (
    <div className='portfolioPage'>
        
      <h3>Portfolio Links</h3>
      <p>Art, Code, General</p>
      <p>This page is a work in progress</p>
    </div>
  );
};

export default PortfolioPage;